module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"no":{"loading":"Laster..."},"en":{"loading":"Loading..."}}')
  delete Component.options._Ctor
}
